import { useMemo,  } from "react";
import { CDataTable, CRow, CSelect } from "@coreui/react";

import { Card } from "components";
import "./Table.scss";
import Pagination from "./Pagination";

const BackendPaginatedTable = ({
  data = [],
  fields = [],
  columnDefinitions = {},
  label = "Items",
  loading = false,
  columnFilter = true,
  showHeader = true,
  headerItems = <></>,
  topTableComponent = <></>,
  onRowClick = () => null,
  onSorterValueChange = () => null,
  hover = true,
  isExternalSort = false,
  handlePageChangeFromParent,
  activePageFromParent,
  totalNumberOfPagesFromParent,
  isTableFullHeight,
  totalElements,
  handleLimitValueChange,
  limitPerPage
}) => {

  const formattedData = useMemo(
    () =>
      data?.map((x) => ({
        ...x,
        _classes: `new-table-row ${hover ? "customHover" : ""}`,
      })),
    [data, hover]
  );
  return (
    <Card 
    className="mb-0 pt-0 backendPaginated-custom-table-container" 
    >
      <CRow 
      className="d-flex px-3 pb-3 pt-2 justify-content-between align-items-center flex-wrap">
        <span style={{ fontWeight: "600" }}>
          {label}  ({totalElements ?? data.length})
        </span>
        <div className="d-flex justify-content-end align-content-center gap-10">
          {headerItems}
          <CSelect
            style={{
              width: "70px",
              padding: "0.3rem 0.7rem",
              display: "inline-block",
              cursor: "pointer",
            }}
            onChange={handleLimitValueChange}
            value={limitPerPage}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="75">75</option>
            <option value="100">100</option>
          </CSelect>
        </div>
      </CRow>

      <div className="p-0 m-0" style={{ border: "none" }}>
        {topTableComponent}
        <CDataTable
          items={formattedData}
          fields={fields}
          loading={loading}
          responsive
          sorter={
            { external: isExternalSort }
          }
          columnFilter={columnFilter}
          itemsPerPage={limitPerPage}
          // activePage={activePageFromParent}
          addTableClasses="table-sm new-custom-table"
          scopedSlots={columnDefinitions}
          onRowClick={onRowClick}
          onSorterValueChange={onSorterValueChange}
          header={showHeader}
        />

        <Pagination
          activePage={activePageFromParent}
          onActivePageChange={handlePageChangeFromParent}
          pages={totalNumberOfPagesFromParent}
        />
      </div>
    </Card>
  );
};

export default BackendPaginatedTable;
